import React from 'react';

function CVSummary({ bio }) {
    return (
        <div className="cv-bio">
            <p>{bio}</p>
        </div>
    );
}

export default CVSummary;